import { useState } from "react";
import { Save } from "lucide-react";
import { api, getApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

function changedFields(edit, customer) {
  const payload = {};
  if (edit.name && edit.name !== customer.name) payload.name = edit.name;
  if (edit.mobile && edit.mobile !== customer.mobile) payload.mobile = edit.mobile;
  if (edit.password) payload.password = edit.password;
  return payload;
}

export const EditCustomerForm = ({ customer, onSaved }) => {
  const [edit, setEdit] = useState({ name: customer.name || "", mobile: customer.mobile || "", password: "" });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setEdit((e) => ({ ...e, [k]: v }));

  const save = async (e) => {
    e.preventDefault();
    const payload = changedFields(edit, customer);
    if (Object.keys(payload).length === 0) return toast.info("Nothing to update");
    setSaving(true);
    try {
      await api.patch(`/admin/customers/${customer.id}`, payload);
      toast.success("Customer updated");
      set("password", "");
      onSaved();
    } catch (err) {
      toast.error(getApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={save} data-testid="edit-customer-form" className="bg-white border border-slate-200 rounded-lg p-6 max-w-2xl space-y-4">
      <div className="space-y-2">
        <Label className="label-overline">Full name</Label>
        <Input data-testid="edit-customer-name" value={edit.name} onChange={(e) => set("name", e.target.value)} />
      </div>
      <div className="space-y-2">
        <Label className="label-overline">Mobile number</Label>
        <Input data-testid="edit-customer-mobile" value={edit.mobile} className="font-mono-num"
          onChange={(e) => set("mobile", e.target.value.replace(/[^0-9+]/g, ""))} />
      </div>
      <div className="space-y-2">
        <Label className="label-overline">Reset password (optional)</Label>
        <Input data-testid="edit-customer-password" type="password" placeholder="Leave blank to keep current"
          value={edit.password} onChange={(e) => set("password", e.target.value)} />
      </div>
      <Button type="submit" disabled={saving} data-testid="save-edit-btn" className="bg-slate-900 hover:bg-slate-800 gap-2">
        <Save className="h-4 w-4" />
        {saving ? "Saving…" : "Save changes"}
      </Button>
    </form>
  );
};
